export default __webpack_public_path__ + "static/34fe82a2-19d9-4b63-8c8a-7860040b01fd-695cb959ec04f2dfe1bc7e9c79d6fd86.woff2";